import React from 'react';
import { useInView } from '../hooks/useInView';
interface IdentitySectionProps {
  handlePurchase: () => void;
}
export function IdentitySection({
  handlePurchase
}: IdentitySectionProps) {
  const [bgRef, bgInView] = useInView({
    rootMargin: '200px'
  });
  const [contentRef, contentInView] = useInView();
  return <section ref={bgRef} aria-label="Featured testimonial" className="relative min-h-[70vh] sm:min-h-[90vh] flex flex-col justify-end items-center pb-12 sm:pb-20 px-4 sm:px-[5%] bg-cover bg-center" style={{
    backgroundImage: bgInView ? "url('https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Retrato_del_Manifestador_El_Ideal_del_Cliente.png?v=1775420936&width=1200&crop=center')" : 'none'
  }} data-id="element-116">
      {/* Overlay */}
      <div className="absolute inset-0 z-[1]" aria-hidden="true" style={{
      background: 'linear-gradient(0deg, #0A0A0B 10%, transparent 50%, #0A0A0B 90%)'
    }} data-id="element-117" />

      {/* Content */}
      <div ref={contentRef} className={`text-center flex flex-col items-center w-full relative z-[2] will-animate animate-fadeIn ${contentInView ? 'is-visible' : ''}`} data-id="element-118">
        <blockquote className="font-serif italic text-2xl sm:text-3xl md:text-[36px] text-white max-w-[700px] mb-4 sm:mb-6 leading-tight drop-shadow-lg" data-id="element-119">
          "My mind finally speaks the same language as money."
        </blockquote>

        <span className="text-gold tracking-[3px] font-extrabold text-[10px] sm:text-xs mb-8 sm:mb-10 drop-shadow-md" data-id="element-120">
          VERIFIED 888 MEMBER
        </span>

        <button onClick={handlePurchase} className="bg-gold text-dark border-none py-4 sm:py-5 px-6 sm:px-8 text-base sm:text-lg font-black rounded cursor-pointer transition-all duration-300 shadow-[0_15px_35px_rgba(212,175,55,0.3)] w-full max-w-[350px] hover:scale-[1.03] hover:bg-[#f1c40f] uppercase tracking-wide" data-id="element-121">
          TRY THE CODE FOR $6.39
        </button>
      </div>
    </section>;
}